import * as types from '../actionTypes';

export function setRegisterPending(isLoading) {
  return {
    type: types.SET_REGISTER_PENDING,
    isLoading,
  };
}

export function setRegisterSuccess(isLoading, data) {
  return {
    type: types.REGISTER,
    isLoading,
    data,
  };
}

export function setRegistrationCode(isLoading, data) {
  return {
    type: types.REGISTER_USER_CONFIRM,
    isLoading,
    data,
  };
}

export function setRegisterError(isLoading, error) {
  return {
    type: types.SET_REGISTER_ERROR,
    isLoading,
    error,
  };
}

export function setRemove() {
  return {
    type: types.SET_REMOVE_ERROR,
  };
}

export function setReset() {
  return {
    type: types.RESET_REGISTER,
  };
}
